<a *ngIf="company$ | async as company" routerLink="{{getLogoLink(company)}}" (click) = "linkLogoClick(company)">
  <img alt="Logo" class="{{class}}" src="{{api_url + company?.logo[0]?.url}}">
</a>
